import { FunctionComponent, ReactNode, useContext } from 'react'
import styled, { css } from 'styled-components'
import contextToiTeaser from '@contexts/toiTeaser'
import { TOITeaserLayoutContextType } from '@contexts/toiTeaser'

type StyledBulletProps = Pick<TOITeaserLayoutContextType, 'accentColor'>

const { TOITeaserLayoutContext } = contextToiTeaser

const StyledBulletPoint = styled.li`
  padding: 0 0 5px 0;
  margin: 0;
  display: flex;
  align-items: flex-start;
`

const StyledBullet = styled.div<StyledBulletProps>`
  ${({ accentColor }) => {
    return css`
      width: 0.5em;
      height: 0.5em;
      border-radius: 50%;
      background-color: ${accentColor};
      margin-top: ${1.2 * 0.25}em;
    `
  }}
`

const StyledBulletText = styled.div`
  padding-left: 0.5em;
  flex: 1;
`

const BulletPoint: FunctionComponent<{ children?: ReactNode }> = ({
  children,
}) => {
  const { accentColor } = useContext(TOITeaserLayoutContext)

  return (
    <StyledBulletPoint>
      <StyledBullet accentColor={accentColor} />
      <StyledBulletText>{children}</StyledBulletText>
    </StyledBulletPoint>
  )
}

export default BulletPoint
